import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../../models/dtos/error.dto';
import { Errors } from '../../../errors';
import getSecondHandRepository, { ServiceResponse } from './getSecondHand.repository';

type InitialState = {
  loading: boolean;
  data?: ServiceResponse[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getSecondHand = createAsyncThunk(
  'getSecondHand',
  async (): Promise<ServiceResponse[]> => {
    return await getSecondHandRepository().catch((error: any) => {
      throw error;
    });
  }
);

const serviceSlice = createSlice({
  name: 'getSecondHand',
  initialState,
  reducers: {
    servicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSecondHand.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
        getSecondHand.fulfilled,
      (state, action: PayloadAction<ServiceResponse[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getSecondHand.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default serviceSlice.reducer;
export const { servicesReset } = serviceSlice.actions;
